angular.module("ainapp")
    .controller("ReconcileChequeRecController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Reconcile Cheque Receipts";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.Filter = {
                    PDCType: "Pending",
                    DateFrom: new Date(),
                    DateTo: new Date(),
                }

                $scope.Load = false;

            }
            $scope.Init();

            $scope.FilterData = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.ClearData = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.FromMonth = $scope.Filter.DateFrom.getMonth() + 1;
                        o.data.FromDay = $scope.Filter.DateFrom.getDate();
                        o.data.FromYear = $scope.Filter.DateFrom.getFullYear();

                        o.data.ToMonth = $scope.Filter.DateTo.getMonth() + 1;
                        o.data.ToDay = $scope.Filter.DateTo.getDate();
                        o.data.ToYear = $scope.Filter.DateTo.getFullYear();

                        o.data.DateFrom = $scope.Filter.DateFrom;
                        o.data.DateTo = $scope.Filter.DateTo;
                        o.data.PDCType = $scope.Filter.PDCType;

                        MainService.ReconcileChequeRecInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Id: {
                                type: "number",
                                editable: false,
                            },
                            Total: {
                                type: "number",
                                editable: false,
                            },
                            PDCNo: {
                                type: "string",
                                editable: false,
                            },
                            ReceiptNo: {
                                type: "string",
                                editable: false,
                            },
                            VoucherNumber: {
                                type: "string",
                                editable: false,
                            },
                            Status: {
                                type: "string",
                                editable: false,
                            },
                            AccountName: {
                                type: "string",
                                editable: false,
                            },
                            BankAccountName: {
                                type: "string",
                                editable: false,
                            },
                            ChequeNo: {
                                type: "string",
                                editable: false,
                            },
                            Remarks: {
                                type: "string",
                                editable: false,
                            },
                            MaturityDate: {
                                type: "date",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {



                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 500,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "VoucherNumber",
                        title: "Voucher No",
                        headerTemplate: $scope.LanguageData.VoucherNo,
                        },
                    {
                        field: "ReceiptNo",
                        title: "Receipt No",
                        headerTemplate: $scope.LanguageData.chequepayNo,
                        },
                    {
                        field: "PDCNo",
                        title: "PDC No",
                        headerTemplate: $scope.LanguageData.PDCNo,
                        },
                    {
                        field: "Date",
                        title: "Date",
                        headerTemplate: $scope.LanguageData.date,
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Total",
                        title: "Amount",
                        headerTemplate: $scope.LanguageData.amount,
                        template: "<div style='text-align: right'>#=kendo.toString(Total, 'n')#</div>",
                        },
                    {
                        field: "Account.Name",
                        title: "PDC Account ",
                        headerTemplate: $scope.LanguageData.PDCAccount,
                        },
                    {
                        field: "BankAccount.Name",
                        title: "Bank Account",
                        headerTemplate: $scope.LanguageData.Bankaccount,
                        },
                    {
                        field: "Status",
                        title: "Status",
                        headerTemplate: $scope.LanguageData.Status,
                        },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        headerTemplate: $scope.LanguageData.Remarks,
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-eye'  ng-click='viewDetail(dataItem)'></button></button><button class=' btn-default btn-sm fa fa-file'  ng-click=\"ViewGl(dataItem.Id, 'Cheque Reconcile Receipt')\"></button>  ",
                        width: '80px',
                        },
                    ],
            };

            $scope.SelectedData = {};

            $scope.viewDetail = function (data) {
                $scope.Load = true;
                MainService.GetReconcileChequeRec(data.Id).then(function (response) {
                    if (response.data) {
                        $('#myModal').modal('show');
                        $scope.SelectedData = response.data;
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                });
            }



                }])
